export default "__VITE_ASSET__ed0270cc__"